/* Stormy Jeans — in-card swipe story gallery (mobile).
   Swipe left/right on a product card image to change photos in place.
   A plain tap still opens the PDP (the card is wrapped in an <a>). */
(function () {
  if (window.__stormyCardSwipe) return;
  window.__stormyCardSwipe = true;

  var THRESHOLD = 30; // px of horizontal travel to count as a real swipe
  var active = null;

  function slideCount(el) { return el.querySelectorAll('.yv-card-swipe-slide').length; }

  function isMobile() {
    return !window.matchMedia || window.matchMedia('(max-width: 767px)').matches;
  }

  // Swap a card's deferred slides (data-src) into real src so swiping never shows a blank.
  function loadSlides(swipe) {
    var imgs = swipe.querySelectorAll('img[data-src]');
    for (var i = 0; i < imgs.length; i++) {
      var im = imgs[i];
      var ss = im.getAttribute('data-srcset');
      if (ss) im.setAttribute('srcset', ss);
      im.setAttribute('src', im.getAttribute('data-src'));
      im.removeAttribute('data-src');
      im.removeAttribute('data-srcset');
    }
  }

  // Hide the arrow that has nowhere to go (at the first / last image).
  function updateArrows(swipe, index, count) {
    var prev = swipe.querySelector('.yv-card-nav-prev');
    var next = swipe.querySelector('.yv-card-nav-next');
    if (prev) prev.classList.toggle('is-hidden', index <= 0);
    if (next) next.classList.toggle('is-hidden', index >= count - 1);
  }

  // Step one image in a direction (used by the side arrows).
  function move(swipe, dir) {
    loadSlides(swipe);
    var track = swipe.querySelector('[data-card-swipe-track]');
    var bars = swipe.querySelectorAll('.yv-card-story-bar');
    var count = swipe.querySelectorAll('.yv-card-swipe-slide').length;
    var index = parseInt(swipe.getAttribute('data-index') || '0', 10) + dir;
    if (index < 0) index = 0;
    if (index > count - 1) index = count - 1;
    track.style.transition = '';
    track.style.transform = 'translateX(' + (-index * 100) + '%)';
    swipe.setAttribute('data-index', index);
    for (var i = 0; i < bars.length; i++) bars[i].classList.toggle('is-active', i === index);
    updateArrows(swipe, index, count);
  }

  var io = null;
  function watch(scope) {
    if (!isMobile()) return; // desktop hides the swipe layer — don't fetch its images
    var cards = (scope || document).querySelectorAll('[data-card-swipe]');
    if ('IntersectionObserver' in window) {
      if (!io) {
        io = new IntersectionObserver(function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) {
              loadSlides(entries[i].target);
              io.unobserve(entries[i].target);
            }
          }
        }, { rootMargin: '400px 0px' }); // start loading a bit before the card is on screen
      }
      for (var j = 0; j < cards.length; j++) io.observe(cards[j]);
    } else {
      for (var k = 0; k < cards.length; k++) loadSlides(cards[k]);
    }
  }

  function onStart(e) {
    var swipe = e.target.closest && e.target.closest('[data-card-swipe]');
    if (!swipe) return;
    loadSlides(swipe); // safety net: guarantee images are in before an interaction
    var t = e.touches ? e.touches[0] : e;
    active = {
      el: swipe,
      track: swipe.querySelector('[data-card-swipe-track]'),
      bars: swipe.querySelectorAll('.yv-card-story-bar'),
      startX: t.clientX,
      startY: t.clientY,
      index: parseInt(swipe.getAttribute('data-index') || '0', 10),
      count: slideCount(swipe),
      moved: false,
      dx: 0,
      dy: 0
    };
  }

  function onMove(e) {
    if (!active) return;
    var t = e.touches ? e.touches[0] : e;
    active.dx = t.clientX - active.startX;
    active.dy = t.clientY - active.startY;
    if (!active.moved && Math.abs(active.dx) > 8 && Math.abs(active.dx) > Math.abs(active.dy)) {
      active.moved = true;
    }
    if (active.moved) {
      if (e.cancelable) e.preventDefault(); // stop the page from scrolling sideways
      var base = -active.index * 100;
      var pct = (active.dx / (active.el.offsetWidth || 1)) * 100;
      active.track.style.transition = 'none';
      active.track.style.transform = 'translateX(' + (base + pct) + '%)';
    }
  }

  function settle() {
    if (!active) return;
    var a = active;
    if (a.moved && Math.abs(a.dx) > THRESHOLD) {
      if (a.dx < 0 && a.index < a.count - 1) a.index++;
      else if (a.dx > 0 && a.index > 0) a.index--;
    }
    a.track.style.transition = '';
    a.track.style.transform = 'translateX(' + (-a.index * 100) + '%)';
    a.el.setAttribute('data-index', a.index);
    for (var i = 0; i < a.bars.length; i++) {
      a.bars[i].classList.toggle('is-active', i === a.index);
    }
    updateArrows(a.el, a.index, a.count);
    if (a.moved) {
      // a real swipe just happened — swallow the click so the <a> doesn't navigate
      a.el.__suppressClick = true;
      setTimeout(function () { a.el.__suppressClick = false; }, 350);
    }
    active = null;
  }

  function onClick(e) {
    // Tap on a side arrow: step slides, never navigate to the PDP.
    var arrow = e.target.closest && e.target.closest('.yv-card-nav');
    if (arrow) {
      e.preventDefault();
      e.stopPropagation();
      var s = arrow.closest('[data-card-swipe]');
      if (s) move(s, arrow.classList.contains('yv-card-nav-next') ? 1 : -1);
      return;
    }
    // Tap right after a swipe: swallow so the <a> doesn't fire.
    var swipe = e.target.closest && e.target.closest('[data-card-swipe]');
    if (swipe && swipe.__suppressClick) {
      e.preventDefault();
      e.stopPropagation();
    }
  }

  document.addEventListener('touchstart', onStart, { passive: true });
  document.addEventListener('touchmove', onMove, { passive: false });
  document.addEventListener('touchend', settle);
  document.addEventListener('touchcancel', settle);
  document.addEventListener('click', onClick, true); // capture: beat the <a> navigation

  // Proactively load images for cards already on the page...
  watch(document);

  // ...and for cards injected later by AJAX (filtering, pagination, cart drawer upsell).
  if ('MutationObserver' in window && document.body) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.matches && n.matches('[data-card-swipe]')) watch(n.parentNode || document);
          else if (n.querySelector && n.querySelector('[data-card-swipe]')) watch(n);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
